enum AssetValuationMethodType {
    MSRP = 'MSRP',
    AVERAGE_RETAIL = 'Average Retail',
    MANUFACTURER_PRICE = 'Manufacturer Price',
    WHOLESALE_PRICE = 'Wholesale Price',
    SALES_PRICE = 'Sales Price',
    VEHICLE_PRICE = 'Vehicle Price',
    CERTIFIED_PRE_OWNED = 'Certified Pre-Owned',
}

export default AssetValuationMethodType
